module.exports = __webpack_public_path__ + "static/media/image-4.110ff7f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/top-home-search/image-4.png
// module id = 2200
// module chunks = 0